import './GoogleBtn.css';
import React, { useEffect } from 'react';
import { FaGoogle } from 'react-icons/fa';
import {
  GoogleLogin,
  CredentialResponse,
  useGoogleLogin,
} from '@react-oauth/google';
import { AuthActions, useAuthDispatch } from '@wajeez-web/stores/auth';
import SVG from 'react-inlinesvg';
import googleLogo from '../assets/google-icon.png';

const GoogleBtn = () => {
  //   const classes = useStyles();
  // const { login } = useLoginWithGoogle();
  const dispatch = useAuthDispatch();

  const responseGoogle = (tokenResponse: CredentialResponse) => {
    if (
      tokenResponse !== null &&
      tokenResponse !== undefined &&
      tokenResponse.credential
    ) {
      dispatch(
        AuthActions.signInWithGoogleAsync({
          token: tokenResponse.credential,
        })
      );
    }
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      console.log('codeResponse', codeResponse);

      dispatch(
        AuthActions.signInWithGoogleAccessTokenAsync({
          token: codeResponse.access_token,
        })
      );
    },
  });

  return (
    <div className="w-[200px]">
      {/* <GoogleLogin
        onSuccess={(credentialResponse) => {
          responseGoogle(credentialResponse);
        }}
        onError={() => {
          console.log('Login Failed');
        }}
      /> */}
      <button onClick={() => login()} className="socialBtn googleLoginBtn">
        {/* <FaGoogle className="social-icon google-icon" color="black" /> */}
        <div className="w-[20px] h-[20px]">
          <img src={googleLogo} alt="Google Logo" />
        </div>
        <span className="text-black">الدخول من خلال جوجل</span>
      </button>
    </div>
  );
};

export default GoogleBtn;
